import React from 'react';
import { AssetsField } from './AssetsField';
import { Grid } from '@material-ui/core';

const AssetsGrid = (props: any): React.ReactElement => {
    return (
        <Grid container spacing={1}>
            {props.ids.map((id, index) => (
                <Grid item lg={2} key={index}>
                    <AssetsField
                        permissions={props.permissions}
                        hasEdit={props.hasEdit}
                        onSelect={props.onSelect}
                        onUnselectItems={props.onUnselectItems}
                        selectedIds={props.selectedIds}
                        basePath={props.basePath}
                        record={props.data[id]}
                        handleAddTransformationToEventstream={props.handleAddTransformationToEventstream}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default AssetsGrid;
